import Vue from 'vue';
import Vuex from 'vuex';
import { setSession } from '@/untils';
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    projectList: JSON.parse(sessionStorage.getItem("projectList")),
    userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
    showName: sessionStorage.getItem("showName"),
    houseList: []
  },
  mutations: {
    getProjectList: (state, value) => {
      sessionStorage.setItem('projectList', JSON.stringify(value))
      state.projectList = value
    },
    getUserInfo: (state, value) => {
      sessionStorage.setItem('userInfo', JSON.stringify(value))
      state.userInfo = value
    },
    setShowName: (state, value) => {
      sessionStorage.setItem('showName', value)
      state.showName = value
    },
    setHouseList: (state, value) => {
      setSession('houseList', value);
      state.houseList = value
    }
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store.js